<div class="dialog-wrap">
  <div class="image-wrap">
    <img *ngIf="file && isImageFile(data.file.fileName)" [src]="file" alt="preview">
  </div>
  <div class="pdf-wrap" *ngIf="file && isPdfFile(data.file.fileName)">
    <pdf-viewer
      [src]="file"
      [rotation]="0"
      [original-size]="false"
      [show-all]="true"
      [fit-to-page]="false"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      [stick-to-page]="false"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"
      style="width: 100%; height: 100vh;"
    ></pdf-viewer>
  </div>
</div>
